<template>
	<div class="quantity-field">
		<button
			class="quantity-field__btn quantity-field__btn--prepend btn btn-sm"
			type="button"
			:disabled="isDisabled || inputValue <= min"
			@click="handleMinus"
		>
			<svg class="icon-svg"><use :href="spritePath + '#minus'"></use></svg>
		</button>
		<input
			ref="input"
			type="number"
			class="quantity-field__field form-control form-control-sm"
			:class="{'is-invalid': isInvalid, 'disabled' : isDisabled}"
			:min="Number(min)"
			:max="Number(max)"
			:step="Number(step)"
			:disabled="isDisabled"
			v-model.number="inputValue"
			@input="handleInput"
			@change="handleChange"
			tabindex="2"
		>
		<button
			class="quantity-field__btn quantity-field__btn--append btn btn-sm"
			type="button"
			:disabled="isDisabled || inputValue >= max"
			@click="handlePlus"
		>
			<svg class="icon-svg"><use :href="spritePath + '#plus'"></use></svg>
		</button>
	</div>
</template>
<script>

const changed = BX.debounce((context) => context.$emit('change'), 250);

export default {

	props: {
		min: {
			type: Number | String,
			default: 1
		},
		max: {
			type: Number | String,
			default: 999
		},
		step: {
			type: Number | String,
			default: 1
		},
		value: {
			type: Number | String,
			default: 'sss'
		},
		isInvalid: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},

	data()
	{
		return {
			inputValue: this.value
		};
	},

	methods: {
		handleInput()
		{
			this.$emit('input', this.inputValue);
		},

		handleButton()
		{
			this.handleInput();
			this.handleChange();
		},

		handleChange()
		{
			changed(this);
		},

		roundValue(value)
		{
			const decimals = String(this.step).includes('.')
				? String(this.step).split('.')[1].length
				: 0,
				multiplier = Math.pow(10, decimals);

			return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
		},

		handlePlus()
		{
			this.inputValue = this.roundValue(this.inputValue + Number(this.step));
			this.handleButton();
		},

		handleMinus()
		{
			this.inputValue = this.roundValue(this.inputValue - Number(this.step));
			this.handleButton();
		}
	},

	computed: {
		spritePath()
		{
			return B2BPortal.config.spritePath;
		},
	},

	watch: {
		value(newVal)
		{
			this.inputValue = newVal;
		}
	}
}
</script>
